import type { CSSProperties, ImgHTMLAttributes } from "react";

type CustomSvgProps = {
    src: string;
    size?: Pick<CSSProperties, "height" | "width">;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "height" | "width">;

export default function CustomSvg({ src, size, ...otherProps }: CustomSvgProps) {
    return <img src={src} style={size} alt="" {...otherProps} />;
}
